var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_459_94",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_459_94",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABL0lEQVR4nO2aPU7DQBSE9xyUKeES8cxKcAHalDkEIRIlfXKK5AKRKGgoOQl3iII2onh6/Dnk7coh80lT2Np93vEbu/A6JSFEUwDckXz9SWVMGjIkH0jueuqx9eLmAJ566OUAE3uVOX1qk5xHGFkdusAKWsnIf+xIJjkF8OzyXY6nkcL318hHGzGGlu4uLcOKN7xGkpFT60jO+cJlfvJFjYkdU+YMzgjJsXtQ33yNcs7VGMvIX1FHDIpWJIqWQdGKRNEyKFqRKFoGRSsSRcugaEWiaBkUrUgUrROM1qjseRh92goo59yY0eCMREAZOdOOLNyXxA2A22BtnJFFuBEAs9YbPKix+9t13RWAbUMTWwCXqQYfr89WHbmvYsKYuSG5/u2ngCO0zjlfVzUhxBnyDlhfgHSz5EYbAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.9479b4d4fbe08c41edd313ac6afca5c3.svg";
export { ForwardRef as ReactComponent };